import SMBankVirtualCollection from '../../containers/BankVirtualCollection'
export const BankVirtualCollectionScreen: React.FC = () => {
    // ======================= VIEWS
    return (
        <>
            <SMBankVirtualCollection />
        </>
    )
}

// ======================= EXPORT
export default BankVirtualCollectionScreen
